export interface DocumentCategory {
  id: string;
  code: string;
  name: string;
  description?: string;
}

export interface DocumentItem {
  id: string;
  title: string;
  description?: string;
  fileName?: string;
  category?: string | DocumentCategory;
  size?: number;
  fileSize?: number;
  tags?: string[];
  summary?: string;
}

/** The list endpoint returns the category either denormalised or as an object. */
export const getCategoryName = (category?: string | DocumentCategory): string | undefined => {
  if (!category) return undefined;
  if (typeof category === 'string') return category;
  return category.name;
};

export const matchesQuery = (doc: DocumentItem, searchQuery: string): boolean => {
  if (!searchQuery) return true;
  const query = searchQuery.toLowerCase();
  const categoryName = getCategoryName(doc.category);
  return Boolean(
    doc.title?.toLowerCase().includes(query) ||
    doc.description?.toLowerCase().includes(query) ||
    doc.fileName?.toLowerCase().includes(query) ||
    categoryName?.toLowerCase().includes(query) ||
    doc.tags?.some((tag) => tag.toLowerCase().includes(query)),
  );
};
